import { Link } from 'react-router-dom';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="mt-6 border-t border-zinc-800/80">
            <div className="w-full px-4 py-6 text-center">
                <p className="text-zinc-500">© Copyright 2020-{currentYear} Meteoric, LLC</p>
                <p className="mt-2 text-sm text-zinc-400">
                    <Link className="text-blue-400 hover:text-blue-300 underline underline-offset-4" to="/terms-and-conditions">
                        Terms and Conditions
                    </Link>
                    <span className="mx-2 text-zinc-600">•</span>
                    <Link className="text-blue-400 hover:text-blue-300 underline underline-offset-4" to="/privacy-policy">
                        Privacy Policy
                    </Link>
                </p>
            </div>
        </footer>
    );
};

export default Footer;
